import { Network } from '@capacitor/network';
import { isNativePlatform } from './platformService.js';

export async function getNetworkStatus() {
  if (!isNativePlatform()) {
    return {
      connected: typeof navigator === 'undefined' || navigator.onLine !== false,
      connectionType: 'unknown',
    };
  }
  return Network.getStatus();
}

export function listenForNetworkChanges(onChange) {
  if (!isNativePlatform()) {
    const onOnline = () => onChange({ connected: true, connectionType: 'unknown' });
    const onOffline = () => onChange({ connected: false, connectionType: 'none' });
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }

  let handle;
  let disposed = false;
  Network.addListener('networkStatusChange', onChange).then((listener) => {
    if (disposed) {
      void listener.remove();
      return;
    }
    handle = listener;
  });

  return () => {
    disposed = true;
    void handle?.remove();
  };
}
